require('../../modules/es.string.iterator');
require('../../modules/es.array.from');
var path = require('../../internals/path');

module.exports = path.Array.from;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/from.js
// module id = 256
// module chunks = 0